import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { apiClient } from '../lib/api-client';
import { useAuthStore } from '../shared/auth/authStore';

export function SsoCompletePage(): JSX.Element {
  const navigate = useNavigate();
  const setUser = useAuthStore((s) => s.setUser);
  const setAccessToken = useAuthStore((s) => s.setAccessToken);

  useEffect(() => {
    // Đọc token và returnTo từ hash (#accessToken=...&returnTo=...) hoặc query string (giống hệt HRM)
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const search = new URLSearchParams(window.location.search);

    const accessToken = hash.get('accessToken') || search.get('accessToken');
    const returnTo = hash.get('returnTo') || search.get('returnTo') || '/';

    if (accessToken) {
      setAccessToken(accessToken);
    }

    const headers: Record<string, string> = {};
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    apiClient
      .get('/auth/session', { headers })
      .then(({ data }) => {
        const user = data?.data ?? data;
        setUser(user);
        navigate(returnTo.startsWith('/') ? returnTo : '/', { replace: true });
      })
      .catch((err) => {
        console.error('Lỗi nạp phiên SSO:', err);
        navigate('/login?error=sso_failed');
      });
  }, [navigate, setUser, setAccessToken]);

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f2f5',
      }}
    >
      <p style={{ fontSize: '14px', color: '#595959' }}>Đang hoàn tất đăng nhập SSO...</p>
    </div>
  );
}
